export const S3_BASE_URL = "https://d3506qpsjjys8u.cloudfront.net/";
